export function getSizeInMb(base64String) {
  const sizeInBytes =
    (base64String.length * 3) / 4 - (base64String.match(/=/g) || []).length;
  return sizeInBytes / (1024 * 1024);
}

export function rotateBase64Image(base64Data, degrees) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Calculate new dimensions after rotation
      const radians = (degrees * Math.PI) / 180;
      const sin = Math.abs(Math.sin(radians));
      const cos = Math.abs(Math.cos(radians));

      canvas.width = img.width * cos + img.height * sin;
      canvas.height = img.width * sin + img.height * cos;

      // Move to center and rotate
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(radians);
      ctx.drawImage(img, -img.width / 2, -img.height / 2);

      // Convert back to base64
      const rotatedBase64 = canvas.toDataURL();
      resolve(rotatedBase64);
    };
    img.src = base64Data;
  });
}

// Function to compress image to stay under 2MB
export function readAndCompress(file, maxSizeMB = 2, quality = 0.8) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      // Set canvas dimensions (you can also resize the image here if needed)
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw image on canvas
      ctx.drawImage(img, 0, 0);

      // Function to get compressed result
      const getCompressedResult = (currentQuality) => {
        return new Promise((resolveBlob) => {
          canvas.toBlob(
            (blob) => {
              const reader = new FileReader();
              reader.onload = (event) => {
                const base64String = event.target.result;
                const sizeInMB = getSizeInMb(base64String);
                resolveBlob({ base64String, sizeInMB, blob });
              };
              reader.readAsDataURL(blob);
            },
            "image/jpeg",
            currentQuality
          );
        });
      };

      // Start with the specified quality and reduce if needed
      const compress = async (currentQuality) => {
        const result = await getCompressedResult(currentQuality);

        if (result.sizeInMB <= maxSizeMB || currentQuality <= 0.1) {
          console.log(
            `Final compressed image size: ${result.sizeInMB.toFixed(
              2
            )} MB (quality: ${currentQuality})`
          );
          resolve(result.base64String);
        } else {
          // Reduce quality and try again
          compress(currentQuality - 0.1);
        }
      };

      compress(quality);
    };

    // Load the image
    const reader = new FileReader();
    reader.onload = (event) => {
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });
}
